export enum IListType {
  Table = 'Table',
  Stack = 'Stack',
}
